/**
 * Définitions des permissions commerçant (alignées sur l'enum Prisma Permission).
 */

export const REQUIRED_PERMISSIONS = [
  'GESTION_COMMANDES',
  'GESTION_PRODUITS',
  'GESTION_HORAIRES',
];

/** Permissions liées au module Caisse (POS) */
export const POS_PERMISSION_KEYS = [
  'GESTION_CAISSE',
  'GESTION_CAISSE_VENTES',
  'GESTION_CAISSE_ENCAISSEMENTS',
  'GESTION_CAISSE_SESSION',
  'GESTION_CAISSE_HISTORIQUE',
];

export const allAvailablePermissions = {
  GESTION_PRODUITS: {
    label: 'Gestion des produits',
    icon: '🍽️',
    description: 'Créer, modifier et supprimer des produits (requis)',
    category: 'produits',
    required: true,
  },
  GESTION_COMMANDES: {
    label: 'Gestion des commandes',
    icon: '📦',
    description: 'Traiter et suivre les commandes (requis)',
    category: 'commandes',
    required: true,
  },
  GESTION_PROMOTIONS: {
    label: 'Gestion des promotions',
    icon: '🎯',
    description: 'Créer et gérer des promotions',
    category: 'marketing',
    required: false,
  },
  GESTION_ANALYTICS: {
    label: 'Analytics et rapports',
    icon: '📊',
    description: 'Consulter les statistiques et rapports',
    category: 'analytics',
    required: false,
  },
  GESTION_NOTIFICATIONS: {
    label: 'Accès Communication',
    icon: '🔔',
    description:
      'Ouvrir le module Communication (envoyer des campagnes). Distinct de l’offre Inclus / Plus gérée par Clickorico.',
    category: 'marketing',
    required: false,
  },
  GESTION_FIDELITE: {
    label: 'Programme de fidélité',
    icon: '⭐',
    description: 'Gérer le programme de fidélité',
    category: 'marketing',
    required: false,
  },
  GESTION_LIVRAISON: {
    label: 'Gestion livraison',
    icon: '🚚',
    description: 'Gérer les livraisons et zones',
    category: 'commandes',
    required: false,
  },
  GESTION_GEOLOCALISATION: {
    label: 'Géolocalisation',
    icon: '📍',
    description: 'Activer/désactiver le suivi GPS des livreurs',
    category: 'commandes',
    required: false,
  },
  GESTION_HORAIRES: {
    label: 'Gestion horaires',
    icon: '🕐',
    description: "Définir les horaires d'ouverture (requis)",
    category: 'configuration',
    required: true,
  },
  GESTION_STOCK: {
    label: 'Ingrédients & ruptures',
    icon: '📦',
    description: 'Gérer les matières premières et leurs ruptures',
    category: 'produits',
    required: false,
  },
  GESTION_AVIS: {
    label: 'Gestion des avis',
    icon: '⭐',
    description: 'Modérer et répondre aux avis',
    category: 'marketing',
    required: false,
  },
  GESTION_CHAT: {
    label: 'Chat client',
    icon: '💬',
    description: 'Communiquer avec les clients',
    category: 'marketing',
    required: false,
  },
  GESTION_CAISSE: {
    label: 'Accès module Caisse (POS)',
    icon: '💳',
    description: 'Affiche le menu Caisse et permet d’ouvrir le module (à activer avec le module en fiche boutique)',
    category: 'pos',
    required: false,
  },
  GESTION_CAISSE_VENTES: {
    label: 'Ventes comptoir',
    icon: '🛒',
    description: 'Créer des ventes sur place depuis le catalogue produits',
    category: 'pos',
    required: false,
  },
  GESTION_CAISSE_ENCAISSEMENTS: {
    label: 'Encaissements',
    icon: '💰',
    description: 'Encaisser commandes web, RDV et réservations en file d’attente',
    category: 'pos',
    required: false,
  },
  GESTION_CAISSE_SESSION: {
    label: 'Sessions & clôture',
    icon: '🔐',
    description: 'Ouvrir/fermer une session de caisse et effectuer la clôture journalière',
    category: 'pos',
    required: false,
  },
  GESTION_CAISSE_HISTORIQUE: {
    label: 'Historique caisse',
    icon: '📋',
    description: 'Consulter l’historique des ventes et encaissements POS',
    category: 'pos',
    required: false,
  },
  GESTION_AR: {
    label: 'Réalité augmentée',
    icon: '🥽',
    description: 'Bientôt disponible',
    category: 'avance',
    required: false,
    disabled: true,
    future: true,
    message: 'Bientôt disponible',
  },
  GESTION_HORS_LIGNE: {
    label: 'Mode hors-ligne',
    icon: '📱',
    description: 'Bientôt disponible',
    category: 'avance',
    required: false,
    disabled: true,
    future: true,
    message: 'Bientôt disponible',
  },
  GESTION_GAMIFICATION: {
    label: 'Gamification',
    icon: '🎮',
    description: 'Bientôt disponible',
    category: 'avance',
    required: false,
    disabled: true,
    future: true,
    message: 'Bientôt disponible',
  },
  GESTION_IOT: {
    label: 'IoT et capteurs',
    icon: '🔌',
    description: 'Bientôt disponible',
    category: 'avance',
    required: false,
    disabled: true,
    future: true,
    message: 'Bientôt disponible',
  },
  GESTION_MAINTENANCE: {
    label: 'Maintenance',
    icon: '🔧',
    description: 'Bientôt disponible',
    category: 'avance',
    required: false,
    disabled: true,
    future: true,
    message: 'Bientôt disponible',
  },
  GESTION_COMMERCANTS: {
    label: 'Gestion des commerçants',
    icon: '🏪',
    description: 'Gérer les autres commerçants',
    category: 'admin',
    required: false,
  },
};

export const categoryConfig = {
  produits: {
    label: 'Produits & Menu',
    icon: '🍽️',
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  commandes: {
    label: 'Commandes & Livraisons',
    icon: '📦',
    color: 'bg-green-50 text-green-700 border-green-200',
  },
  marketing: {
    label: 'Marketing & Communication',
    icon: '📢',
    color: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  analytics: {
    label: 'Analytics & Rapports',
    icon: '📊',
    color: 'bg-orange-50 text-orange-700 border-orange-200',
  },
  configuration: {
    label: 'Configuration',
    icon: '⚙️',
    color: 'bg-gray-50 text-gray-700 border-gray-200',
  },
  pos: {
    label: 'Caisse (POS)',
    icon: '💳',
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  avance: {
    label: 'Fonctionnalités Avancées',
    icon: '🚀',
    color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  },
  admin: {
    label: 'Administration',
    icon: '🏪',
    color: 'bg-red-50 text-red-700 border-red-200',
  },
};

export function mergeWithRequiredPermissions(permissions = []) {
  return [...new Set([...REQUIRED_PERMISSIONS, ...(permissions || [])])];
}

/** Clés affichées / enregistrables (hors permissions « bientôt » désactivées). */
export const ALL_PERMISSION_KEYS = Object.keys(allAvailablePermissions).filter(
  (key) => !allAvailablePermissions[key].disabled && !allAvailablePermissions[key].future,
);

/** Retire legacy / inconnues (ex. GESTION_MENU) avant affichage ou envoi API. */
export function normalizePermissionsFromApi(permissions = []) {
  const allowed = new Set(ALL_PERMISSION_KEYS);
  const cleaned = (permissions || []).filter((p) => allowed.has(p));
  return mergeWithRequiredPermissions(cleaned);
}

/** Liste unique et valide pour PUT /permissions (sans doublons). */
export function sanitizePermissionsForSave(permissions = []) {
  const allowed = new Set(ALL_PERMISSION_KEYS);
  const cleaned = (permissions || []).filter((p) => allowed.has(p));
  return mergeWithRequiredPermissions(cleaned);
}

export function countSelectablePermissions(permissions = []) {
  const normalized = normalizePermissionsFromApi(permissions);
  return normalized.length;
}

export function hasAnyPosPermission(permissions = []) {
  return (permissions || []).some(
    (p) => p === 'GESTION_CAISSE' || String(p).startsWith('GESTION_CAISSE_'),
  );
}

export function isPlatformAdminRole(role) {
  return role === 'SUPER_ADMIN' || role === 'super-admin' || role === 'ADMIN';
}

/**
 * Compte commerçant réel uniquement.
 * L’assistance SUPER_ADMIN ne diminue pas les droits plateforme :
 * le contexte boutique change, le rôle SUPER_ADMIN reste intact.
 */
export function isMerchantViewRole(role) {
  return role === 'COMMERCANT' || role === 'commercant';
}

export function canManagePlatformModules(role) {
  return isPlatformAdminRole(role) && !isMerchantViewRole(role);
}
